import { createCachedSelector } from 're-reselect';
import { useMemo } from 'react';
import { useQuery } from 'react-query';
import { useRecoilValue } from 'recoil';
import * as sharedAtoms from '../../atoms/shared';
import * as api from '../../services/api';
import useAccount from './useAccount';

const selector = createCachedSelector(
  (data) => data.data,
  (data) => {
    const orders = data || [];
    return {
      orders
    };
  }
)({
  keySelector: (data, storeKey) => storeKey.join('#')
});

const useBranchOrders = () => {
  const { accountId } = useAccount();
  const branchId = useRecoilValue(sharedAtoms.selectedBranch);
  const storeKey = ['orders', 'branches', branchId];
  const { isLoading, data } = useQuery(storeKey, () => api.fetchBranchOrders({ accountId, branchId }), {
    enabled: !!accountId && !!branchId,
    cacheTime: 0,
    select: (branchesOrdersData) => selector(branchesOrdersData, storeKey)
  });

  const { orders } = useMemo(() => {
    const { orders: rawOrders } = data || {};
    return {
      orders: rawOrders
    };
  }, [data]);

  return {
    isLoading,
    orders
  };
};

export default useBranchOrders;
